import { Settings } from "lucide-react";

import { Label } from "js/components/ui/label";
import { RadioGroup, RadioGroupItem } from "js/components/ui/radio-group";

import { StepComponentProps } from "../types";

export const Step4FinalConfiguration = ({
  formData,
  updateFormData,
  isAnimating,
}: StepComponentProps) => {
  const blindajeSelection: "yes" | "no" | undefined =
    formData.alternativeJustice === null
      ? undefined
      : formData.alternativeJustice
        ? "yes"
        : "no";

  const premiumSelection: "yes" | "no" | undefined =
    formData.rentInsurance === null
      ? undefined
      : formData.rentInsurance
        ? "yes"
        : "no";

  const tenantPaysSelection: "yes" | "no" | undefined =
    formData.tenantPaysApplication === null
      ? undefined
      : formData.tenantPaysApplication
        ? "yes"
        : "no";

  const blindajeValue = blindajeSelection ?? "";
  const premiumValue = premiumSelection ?? "";
  const tenantPaysValue = tenantPaysSelection ?? "";

  const hasAnsweredBlindaje = formData.alternativeJustice !== null;
  const showPremiumStep = formData.alternativeJustice === true;
  const showTenantPaymentStep =
    (hasAnsweredBlindaje && formData.alternativeJustice === false) ||
    (formData.alternativeJustice === true && formData.rentInsurance !== null);

  const handleBlindajeChange = (value: string) => {
    if (value !== "yes" && value !== "no") return;

    updateFormData("alternativeJustice", value === "yes");
    updateFormData("rentInsurance", null);
  };

  const handlePremiumChange = (value: string) => {
    if (value !== "yes" && value !== "no") return;
    updateFormData("rentInsurance", value === "yes");
  };

  const handleTenantPaysChange = (value: string) => {
    if (value !== "yes" && value !== "no") return;
    updateFormData("tenantPaysApplication", value === "yes");
  };

  return (
    <div
      className={`space-y-8 transition-all duration-500 ${isAnimating ? "opacity-0 translate-x-4" : "opacity-100 translate-x-0"}`}
    >
      <div className="space-y-6">
        <div className="flex items-center gap-3 pb-4">
          <Settings className="w-5 h-5 text-gray-700" />
          <h3 className="text-lg font-semibold text-gray-900">
            Configuración Final
          </h3>
        </div>
        <div className="space-y-4">
          <div className="border border-gray-200 rounded-lg p-6">
            <div className="space-y-2">
              <p className="text-sm font-semibold text-gray-900">
                Blindaje Legal Multiprotección
              </p>
              <p className="text-xs text-gray-600">
                ¿Quieres añadir el Contrato de Arrendamiento y Convenio de
                Justicia Alternativa?
              </p>
              <p className="text-xs text-gray-600">
                <span className="font-semibold text-gray-700">Beneficio:</span>{" "}
                No esperes a aprobar para empezar el contrato. Avanza ambos en
                paralelo y cierra sin fricción.
              </p>
            </div>
            <RadioGroup
              value={blindajeValue}
              onValueChange={handleBlindajeChange}
              className="mt-4 space-y-3"
            >
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="yes" id="blindaje-yes" />
                <Label htmlFor="blindaje-yes" className="text-sm text-gray-700">
                  Sí, proteger mi arrendamiento.
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="no" id="blindaje-no" />
                <Label htmlFor="blindaje-no" className="text-sm text-gray-700">
                  No por ahora.
                </Label>
              </div>
            </RadioGroup>
          </div>

          {showPremiumStep && (
            <div className="border border-gray-200 rounded-lg p-6 animate-in fade-in slide-in-from-top-2 duration-400">
              <div className="space-y-2">
                <p className="text-sm font-semibold text-gray-900">
                  ⭐ Conviértelo en PREMIUM ⭐
                </p>
                <p className="text-xs text-gray-600">
                  ¿Añadir la Póliza de Renta Protegida?
                </p>
                <p className="text-xs text-gray-600">
                  <span className="font-semibold text-gray-700">
                    Beneficio:
                  </span>{" "}
                  Nosotros nos encargamos de todo el proceso y cubrimos el 100%
                  de los honorarios de abogados hasta recuperar el inmueble.
                </p>
              </div>
              <RadioGroup
                value={premiumValue}
                onValueChange={handlePremiumChange}
                className="mt-4 space-y-3"
              >
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="yes" id="premium-yes" />
                  <Label
                    htmlFor="premium-yes"
                    className="text-sm text-gray-700"
                  >
                    Sí, quiero la máxima tranquilidad.
                  </Label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="no" id="premium-no" />
                  <Label htmlFor="premium-no" className="text-sm text-gray-700">
                    No, gracias.
                  </Label>
                </div>
              </RadioGroup>
            </div>
          )}

          {showTenantPaymentStep && (
            <div className="border border-gray-200 rounded-lg p-6 animate-in fade-in slide-in-from-top-2 duration-400">
              <div className="space-y-2">
                <p className="text-sm font-semibold text-gray-900">
                  Pago por el Inquilino
                </p>
                <p className="text-xs text-gray-600">
                  ¿El inquilino cubrirá el costo de esta solicitud?
                </p>
              </div>
              <RadioGroup
                value={tenantPaysValue}
                onValueChange={handleTenantPaysChange}
                className="mt-4 space-y-3"
              >
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="yes" id="tenant-pays-yes" />
                  <Label
                    htmlFor="tenant-pays-yes"
                    className="text-sm text-gray-700"
                  >
                    Sí
                  </Label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="no" id="tenant-pays-no" />
                  <Label
                    htmlFor="tenant-pays-no"
                    className="text-sm text-gray-700"
                  >
                    No
                  </Label>
                </div>
              </RadioGroup>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
